import { Recharge } from "../../views/amount/recharge";
import { Withdrawal } from "../../views/amount/withdrawal";
import { BalanceLog } from "../../views/amount/balanceLog";
import { UserAddress } from "../../views/amount/userAddress";
import { UserTransfer } from "../../views/amount/UserTransfer";

import { langPage } from "../../locales";


const lang = langPage?.amount;

export const amountRouters = [
    {
        path: "/amount/userAddress",
        name: "userAddress",
        exact: true,
        component: UserAddress,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.userAddress?.name,
                    path: ""
                }
            ],
            privilegeCode: "userAddress",
        }
    },
    {
        path: "/amount/recharge",
        name: "recharge",
        exact: true,
        component: Recharge,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.recharge?.name,
                    path: ""
                }
            ],
            privilegeCode: "recharge",
        }
    },
    {
        path: "/amount/withdrawal",
        name: "withdrawal",
        exact: true,
        component: Withdrawal,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.withdrawal?.name,
                    path: ""
                }
            ],
            privilegeCode: "withdrawal",
        }
    },
    {
        path: "/amount/balanceLog",
        name: "balanceLog",
        exact: true,
        component: BalanceLog,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.balanceLog?.name,
                    path: ""
                }
            ],
            privilegeCode: "balanceLog",
        }
    },
    {
        path: "/amount/userTransfer",
        name: "userTransfer",
        exact: true,
        component: UserTransfer,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "用户转账列表",
                    path: ""
                }
            ],
            privilegeCode: "userTransfer",
        }
    },
];
